import { render, staticRenderFns } from "./ValidateExpenses.vue?vue&type=template&id=8d563048&"
import script from "./ValidateExpenses.vue?vue&type=script&lang=js&"
export * from "./ValidateExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports